import Formsy, {addValidationRule} from 'formsy-react';
import {
    mobileNumberRegex,
    validBankAcctRegex,
    validSSNRegex,
    validWebsiteRegex,
    validEnglishOnlyFieldRegex,
    validYearRegex
} from '../../constants/Regex';

addValidationRule('checked', (values, value) => !!value);

addValidationRule('isMobileNumber', (values, value) => {
    if (value) {
        const extValue = value.replace(/-/g, '');
        return mobileNumberRegex.test(extValue);
    }
    return true;
});

addValidationRule('isValidSSN', (values, value) => {
    if (value) {
        return validSSNRegex.test(value);
    }
    return true;
});

addValidationRule('isValidBandAccountNo', (values, value) => {
    if (value) {
        return validBankAcctRegex.test(value);
    }
    return true;
});

addValidationRule('RichTextRequired', (values, value = '') => {
    const trimValue = value ? value.replace(/<\/?[^>]+(>|$)/g, '') : '';
    return !!trimValue;
});

addValidationRule('isWebsite', (values, value = '') => {
    if (value) {
        return validWebsiteRegex.test(value);
    }
    return true;
});

addValidationRule('isDate', (values, value) => {
    const d = new Date(value);
    if (
        d instanceof Date &&
        !isNaN(d.getTime()) && // eslint-disable-line no-restricted-globals
        validYearRegex.test(d.getFullYear())
    ) {
        return true;
    }
    return false;
});

addValidationRule('isArray', (values, value) => Array.isArray(value));

addValidationRule('notEmptyImage', (values, value) => typeof value === 'object' || value.length);

addValidationRule(
    'validImageDimension',
    (values, value) =>
        Array.isArray(value) &&
        !value.filter(item => item && item.invalid === 'validImageDimension').length
);

addValidationRule(
    'validImageType',
    (values, value) =>
        Array.isArray(value) && !value.filter(item => item && item.invalid === 'imageType').length
);

addValidationRule(
    'pngImage',
    (values, value) =>
        Array.isArray(value) && value.every(item => item && (item.url || item.extension === 'png'))
);

addValidationRule(
    'perImageSize',
    (values, value, size) =>
        Array.isArray(value) && value.every(item => item && (item.url || item.size <= size))
);

addValidationRule('totalImageSize', (values, value, size) => {
    if (!Array.isArray(value)) {
        return false;
    }
    let total = 0;
    value.forEach(itm => {
        total += itm.size;
    });
    return total <= size;
});

addValidationRule(
    'imageName',
    (values, value) =>
        Array.isArray(value) &&
        value.every(item => item && (item.url || item.name.match(/\w*_screenshot[0-9]*\.png/)))
);

addValidationRule('validRoutingNumber', (values, value) => {
    if (!value) {
        return true;
    }

    // all valid routing numbers are 9 numbers in length
    if (value.length !== 9) {
        return false;
    }

    // routing numbers starting with 5 are internal routing numbers
    // usually found on bank deposit slips
    if (value[0] === '5') {
        return false;
    }

    // http://en.wikipedia.org/wiki/Routing_transit_number#MICR_Routing_number_format
    const checksumTotal =
        7 *
            (parseInt(value.charAt(0), 10) +
                parseInt(value.charAt(3), 10) +
                parseInt(value.charAt(6), 10)) +
        3 *
            (parseInt(value.charAt(1), 10) +
                parseInt(value.charAt(4), 10) +
                parseInt(value.charAt(7), 10)) +
        9 *
            (parseInt(value.charAt(2), 10) +
                parseInt(value.charAt(5), 10) +
                parseInt(value.charAt(8), 10));

    const checksumMod = checksumTotal % 10;
    return checksumMod === 0;
});

addValidationRule('w9form', (values, value) => !!value);

addValidationRule('validEnglishOnlyField', (values, value) => {
    if (value && validEnglishOnlyFieldRegex.test(value)) {
        return true;
    }
    return false;
});

export default Formsy;
